import React from "react";
import "../ViewTeacher/ViewTeacher.css";

function ViewTeacher({ teacher, onClose }) {
  // Function to format date to DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch {
      return "Invalid Date";
    }
  };

  // Fallback for missing teacher data
  if (!teacher) {
    return (
      <div className="view-teacher-container">
        <div className="view-teacher">
          <div className="view-teacher-header">
            <h2>Teacher Details</h2>
          </div>
          <div className="teacher-details">
            <p>No teacher data available.</p>
          </div>
          <div className="view-teacher-btn">
            <button className="view-teacher-btn-close" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="view-teacher-container">
      <div className="view-teacher">
        <div className="view-teacher-header">
          <h2>Teacher Details</h2>
        </div>
        <div className="teacher-details">
          {/* Row 1: Name, Subject, Section */}
          <div className="teacher-name-subject-section">
            <div className="teacher-name">
              <h4>Name</h4>
              <div className="teacherName">{teacher.name || "N/A"}</div>
            </div>
            <div className="teacher-subject">
              <h4>Subject</h4>
              <div className="subject">{teacher.subject || "N/A"}</div>
            </div>
            <div className="teacher-section">
              <h4>Section</h4>
              <div className="section">{teacher.section || "D"}</div>
            </div>
          </div>

          {/* Row 2: Class Teacher, Email, Phone */}
          <div className="teacher-classteacher-email-phone">
            <div className="teacher-classteacher">
              <h4>Class Teacher</h4>
              <div className="classteacher">{teacher.classteacher || "N/A"}</div>
            </div>
            <div className="teacher-email">
              <h4>Email</h4>
              <div className="email">{teacher.email || "N/A"}</div>
            </div>
            <div className="teacher-phone">
              <h4>Phone</h4>
              <div className="phone">{teacher.phone || "N/A"}</div>
            </div>
          </div>

          {/* Row 3: Gender, Degree, City, Join Date */}
          <div className="teacher-gender-degree-city-joinDate">
            <div className="teacher-gender">
              <h4>Gender</h4>
              <div className="gender">{teacher.gender || "N/A"}</div>
            </div>
            <div className="teacher-degree">
              <h4>Degree</h4>
              <div className="degree">{teacher.degree || "N/A"}</div>
            </div>
            <div className="teacher-city">
              <h4>City</h4>
              <div className="city">{teacher.city || "N/A"}</div>
            </div>
            <div className="teacher-joinDate">
              <h4>Join Date</h4>
              <div className="joinDate">{formatDate(teacher.joinDate)}</div>
            </div>
          </div>
        </div>

        {/* Close Button */}
        <div className="view-teacher-btn">
          <button className="view-teacher-btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewTeacher;